import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetProductsForLead_lead_products_edges as LeadProductMap,
    RemoveProductForLead as RemoveProductForLeadMutation,
    RemoveProductForLeadVariables,
} from 'nutshell-graphql-types';

import REMOVE_PRODUCT_FOR_LEAD from '../mutations/remove-product-for-lead.graphql';

export const useRemoveProductForLead = (): {
    removeProductForLead: (arg1: LeadProductMap) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [removeProductForLead, {loading, error}] = useMutation<
        RemoveProductForLeadMutation,
        RemoveProductForLeadVariables
    >(REMOVE_PRODUCT_FOR_LEAD);

    return {
        removeProductForLead: (leadProductMap: LeadProductMap) =>
            removeProductForLead({variables: {input: {leadProductMap: leadProductMap.id}}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
